/**
 * @generated SignedSource<<241067af5e0ae393089effab21cbcc8a>>
 * @relayHash 3d04f8c6c1a1d7301e7884cf410fd5c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 828b6b87e19f2b120a25e525514bd71dc852df11a9cb73b98e092b00105074f8

import type { ConcreteRequest } from 'relay-runtime';
export type useDefaultAndSpaceClassificationLevelsQuery$variables = {
  spaceKey: string;
};
export type useDefaultAndSpaceClassificationLevelsQuery$data = {
  readonly classificationLevels: ReadonlyArray<{
    readonly color: string | null | undefined;
    readonly description: string | null | undefined;
    readonly guideline: string | null | undefined;
    readonly guidelineADF: string | null | undefined;
    readonly id: string;
    readonly name: string;
    readonly order: number | null | undefined;
    readonly status: string;
  }> | null | undefined;
  readonly space: {
    readonly defaultClassificationLevelId: string | null | undefined;
    readonly id: string | null | undefined;
    readonly metadata: {
      readonly totalCurrentPages: AGG$Long;
    };
    readonly name: string | null | undefined;
  } | null | undefined;
};
export type useDefaultAndSpaceClassificationLevelsQuery = {
  response: useDefaultAndSpaceClassificationLevelsQuery$data;
  variables: useDefaultAndSpaceClassificationLevelsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = {
  "kind": "ScalarField",
  "name": "name"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "kind": "ScalarField",
        "name": "defaultClassificationLevelId"
      },
      {
        "concreteType": "SpaceMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "totalCurrentPages"
          }
        ]
      }
    ]
  },
  {
    "concreteType": "ContentDataClassificationLevel",
    "kind": "LinkedField",
    "name": "classificationLevels",
    "plural": true,
    "selections": [
      (v1/*: any*/),
      {
        "kind": "ScalarField",
        "name": "order"
      },
      {
        "kind": "ScalarField",
        "name": "status"
      },
      {
        "kind": "ScalarField",
        "name": "color"
      },
      {
        "kind": "ScalarField",
        "name": "description"
      },
      {
        "kind": "ScalarField",
        "name": "guideline"
      },
      {
        "kind": "ScalarField",
        "name": "guidelineADF"
      },
      (v2/*: any*/)
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "3d04f8c6c1a1d7301e7884cf410fd5c8",
    "id": "828b6b87e19f2b120a25e525514bd71dc852df11a9cb73b98e092b00105074f8",
    "metadata": {},
    "name": "useDefaultAndSpaceClassificationLevelsQuery",
    "operationKind": "query",
    "text": "query useDefaultAndSpaceClassificationLevelsQuery($spaceKey:String!){space(key:$spaceKey){id,name,defaultClassificationLevelId,metadata{totalCurrentPages}},classificationLevels{id,order,status,color,description,guideline,guidelineADF,name}}"
  }
};
})();

(node as any).hash = "be080d8a317cb377c657a1902f8dd277";

export default node;
